import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

/**
 * v7 Experience checkbox — matches HTML `.check` / `.check.off`.
 * Green square with ✓ when on; empty bordered square when off.
 *
 * Works controlled (`checked` + `onChange`) or with Formik via `name`
 * when used inside Formik context through the companion field wrapper.
 */
const ExperienceCheckbox = ({
  checked = false,
  onChange,
  onBlur,
  label,
  disabled = false,
  className,
  id,
  name,
  extra,
}) => {
  const handleToggle = () => {
    if (disabled) return
    if (typeof onChange === 'function') {
      onChange({
        target: {
          name,
          type: 'checkbox',
          checked: !checked,
          value: !checked,
        },
      })
    }
  }

  return (
    <label
      id={id}
      className={classNames(
        'experience-check-btn',
        { off: !checked, 'is-disabled': disabled },
        className,
      )}
      onClick={(e) => {
        e.preventDefault()
        handleToggle()
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleToggle()
        }
      }}
      onBlur={onBlur}
      role='checkbox'
      aria-checked={!!checked}
      tabIndex={disabled ? -1 : 0}>
      <i aria-hidden='true'>✓</i>
      <span className='experience-check-btn-label'>{label}</span>
      {extra}
    </label>
  )
}

ExperienceCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  extra: PropTypes.node,
}

export default ExperienceCheckbox
